import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    userId: null,
    userName: null,
    userRole: null,
    userData: null,
    subscription: null,
    token: null,
    permissions: [], // Array of permission strings for the user's assigned role
    userRoleData: null, // { name, description } of the assigned Role document
    isImpersonating: false,
    impersonator: null,
  },
  reducers: {
    setAuthData(state, action) {
      const { userId, userName, userRole, userData, subscription, token, permissions, userRoleData } =
        action.payload;
      state.userId = userId;
      state.userName = userName;
      state.userRole = userRole;
      state.userData = userData;
      state.token = token;
      state.permissions = permissions || [];
      state.userRoleData = userRoleData || null;
    },
    setSubscription(state, action) {
      state.subscription = action.payload;
    },
    startImpersonation(state, action) {
      state.isImpersonating = true;
      state.impersonator = action.payload;
    },
    restoreImpersonation(state) {
      if (state.impersonator) {
        const { userId, userName, userRole, userData, subscription, token } =
          state.impersonator;
        state.userId = userId;
        state.userName = userName;
        state.userRole = userRole;
        state.userData = userData;
        state.subscription = subscription;
        state.token = token;
      }
      state.impersonator = null;
      state.isImpersonating = false;
    },
    clearAuthData(state) {
      state.userId = null;
      state.userName = null;
      state.userRole = null;
      state.userData = null;
      state.subscription = null;
      state.token = null;
      state.isImpersonating = false;
      state.impersonator = null;
    },
  },
});

export const { setAuthData, setSubscription, startImpersonation, restoreImpersonation, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
